import { format } from "date-fns";
import { formatSupplierUnitPrice } from "@shared/supplier-unit-price";

export function displayReceiptChangeUnitPrice(value: unknown): string {
  if ((typeof value !== "string" && typeof value !== "number") || value === "") return "—";
  try {
    return formatSupplierUnitPrice(value);
  } catch {
    return "—";
  }
}

export function asObjectArray(value: unknown): Array<Record<string, any>> {
  return Array.isArray(value)
    ? value.filter((item): item is Record<string, any> =>
        item !== null && typeof item === "object" && !Array.isArray(item))
    : [];
}

export function formatReceiptChangeDate(value: unknown, pattern: string): string {
  if (!value || (typeof value !== "string" && typeof value !== "number" && !(value instanceof Date))) {
    return "—";
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : format(date, pattern);
}

export function displayReceiptChangeScalar(value: unknown, fallback = "—"): string {
  if (typeof value === "string") return value || fallback;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value === "boolean") return String(value);
  return fallback;
}

export function displayReceiptChangeMoney(value: unknown): string {
  if (typeof value !== "string" && typeof value !== "number") return "—";
  if (typeof value === "string" && value.trim() === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? number.toFixed(2) : "—";
}